import { Component, OnInit } from '@angular/core';
import {MatOptionSelectionChange} from '@angular/material/core';
import {FormGroup} from '@angular/forms';
import {PatientSccaiResults, Q_PATIENT_SCCAI} from '../../../../model/questionnaires/questionnaire-patient-sccai';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';

@Component({
  selector: 'app-questionnaire-patient-sccai',
  templateUrl: './questionnaire-patient-sccai.component.html',
  styleUrls: ['./questionnaire-patient-sccai.component.css']
})
export class QuestionnairePatientSCCAIComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_PATIENT_SCCAI;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  results = [];
  q = 'question';
  found = false;
  finalScore = 0;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'PATIENT-SCCAI';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.qForm = new FormGroup({});

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  onSubmit(value: any) {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Non hai finito di completare il questionario!';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {
        console.log(this.finalScore);
        const resultToSend = new PatientSccaiResults(this.doctorID, this.patientSSN, this.results, this.finalScore);
        this.questionnaireService.sendForm(resultToSend, 'patient-sccai', this.uuid);
      }
    }
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number, answers: string[]) {
    if ($event.isUserInput) {
      console.log(value, position, answers);
      if (position === 7) {
        if (this.results[position - 1] !== null) {
          console.log('Precedente: ', this.results[position - 1]);
          console.log('Final Score Before: ', this.finalScore);
          if (parseInt(this.results[position - 1], 10) >= 7) {
            this.finalScore -= 0;
          } else if (parseInt(this.results[position - 1], 10) === 6) {
            this.finalScore -= 1;
          } else if (parseInt(this.results[position - 1], 10) === 5) {
            this.finalScore -= 2;
          } else if (parseInt(this.results[position - 1], 10) === 4) {
            this.finalScore -= 3;
          } else if (parseInt(this.results[position - 1], 10) < 4) {
            this.finalScore -= 4;
          }
          console.log('Final Score After: ', this.finalScore);
        }
        if (parseInt(value, 10) >= 7) {
          this.finalScore += 0;
        } else if (parseInt(value, 10) === 6) {
          this.finalScore += 1;
        } else if (parseInt(value, 10) === 5) {
          this.finalScore += 2;
        } else if (parseInt(value, 10) === 4) {
          this.finalScore += 3;
        } else if (parseInt(value, 10) < 4) {
          this.finalScore += 4;
        }
      } else {
        if (this.results[position - 1] !== null) {
          let dec = 0;
          answers.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After: != 7', this.finalScore);
            }
            dec++;
          });
        }
        let inc = 0;
        answers.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc++;
        });
      }

      this.results[position - 1] = value;

      console.log('Risposta: ', value);
      console.log('Risultati: ', this.results);
      console.log('Final Score: ', this.finalScore);

    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}
